import Shelf, { type ShelfProps } from '@components/storeMap/floor/2d/Shelf'
import { useTodoListContext } from '@routes/TodoList/Context'

interface OOSShelfProps extends ShelfProps {
  selectedShelfId?: string
}

const TODO_COLORS = {
  done: {
    primary: 'var(--color-todo-done)',
    secondary: 'var(--color-todo-done-secondary)',
  },
  REFILL: {
    primary: 'var(--color-todo-action-refill)',
    secondary: 'var(--color-todo-action-refill-secondary)',
  },
  CHECK: {
    primary: 'var(--color-todo-action-check)',
    secondary: 'var(--color-todo-action-check-secondary)',
  },
  REORDER: {
    primary: 'var(--color-todo-action-reorder)',
    secondary: 'var(--color-todo-action-reorder-secondary)',
  },
}

function TodoShelf({ shelf, ...props }: OOSShelfProps) {
  const { selectedTask, filteredTodoList, selectedShelfId, setSelectedShelfId } = useTodoListContext()

  const isSelected = shelf.id === selectedShelfId || shelf.id === selectedTask?.shelfId
  const todoItem = filteredTodoList.find(item => item.shelfId === shelf.id)

  let fill = isSelected ? 'var(--color-shelf-selected)' : undefined
  let stroke = isSelected ? 'var(--color-shelf-selected)' : undefined

  if (todoItem) {
    const statusKey = todoItem.isCompleted() ? 'done' : todoItem.action as keyof typeof TODO_COLORS
    const colors = TODO_COLORS[statusKey]

    fill = isSelected ? colors.primary : colors.secondary
    stroke = colors.primary
  }

  return <Shelf shelf={shelf} fill={fill} stroke={stroke} {...props} onShelfClick={setSelectedShelfId} />
}

export default TodoShelf